
<draggable
	:disabled="disabled"
	:list="list"
	:move="checkMove"
	:handle="handle && '.handle'"
	v-bind="dragOptions"
	@start="dragStart"
	@end="dragEnd"
>
	<slot />
</draggable>
